window.addEventListener('keydown', function(e) {
	if (e.key === 'g' && e.ctrlKey) {
		document.body.classList.toggle('show-grid-vertical');
	}
	if (e.key === 'l' && e.ctrlKey) {
		document.body.classList.toggle('show-grid-horizontal');
	}
})